import React, {useEffect} from 'react';
import Grid from "@material-ui/core/Grid";
import {useOvermind} from "../Others/OvermindHelper";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import CircularProgress from '@material-ui/core/CircularProgress';
import {BusinessLogics} from "../Others/BusinessLogics";
import {FirebaseHelper} from "../Others/FirebaseHelper";
import {useHistory} from "react-router-dom";
import Snackbar from '@material-ui/core/Snackbar';
import MetaTags from 'react-meta-tags';

const styles = {
    buttons: {
        width: '100%',
    },
    buttonGrid: {
        margin: 4
    },
    textfield: {
        marginLeft: 24,
        marginRight: 24,
    },
    linktextfield: {
        marginTop: 16,
        marginLeft: 24,
        marginRight: 24
    }
}


const DataAdderShowerDeleter = (props) => {
    const {id = ""} = props.match.params
    const {state, actions} = useOvermind()

    const history = useHistory();

    function changeRoute(route) {
        history.push(route);
    }

    useEffect(() => {
        if (id) {
            try {
                FirebaseHelper.init()
            } catch (e) {

            }
            BusinessLogics.getOneData(id, actions, changeRoute)
        }
    }, [])

    return (
        <Grid container direction='column'>
            <MetaTags>
                <title>53CR3T M3554G3 {id}</title>
                <meta name="description" content={`53CR3T M3554G3 ${id}`}/>
                <meta property="og:title" content={`53CR3T M3554G3 ${id}`}/>
            </MetaTags>
            {
                state.link ?
                    <Grid style={{paddingLeft: 24, paddingRight: 24}} container direction='column'>
                        <Typography style={{color: "#1B5E20", fontSize: 12, lineHeight: 1}}
                                    variant='overline'>
                            * Secret Message *</Typography>
                        <Typography style={{
                            borderRadius: 4,
                            padding: 8,
                            marginTop: 4,
                            lineHeight: 1,
                            border: "#1B5E20",
                            borderWidth: 2,
                            borderStyle: 'solid'
                        }}
                                    variant='body1'>{state.add.message || state.show.message}</Typography>
                    </Grid>
                    :
                    <TextField
                        label="Secret Message"
                        onChange={(e) => {
                            actions.setAddObj({
                                message: "" + e.target.value
                            })
                        }}
                        value={state.add.message}
                        style={styles.textfield}
                        rowsMax={state.show.message ? 0 : 10} rows={state.show.message ? 0 : 10}
                        autoFocus={true}
                        multiline={true}
                        variant='outlined'
                        error={state.add.message.length > 1000}
                        required={true}
                        placeholder="Enter your message"
                    />
            }

            <Grid style={{paddingTop: 4, paddingLeft: 28, paddingRight: 28}} container direction='row'
                  justify='space-between'>
                <Typography variant='subtitle2'>Character
                    count: {state.show.message.length || state.add.message.length}</Typography>
                <Typography variant='subtitle2'>Max Characters: 1000</Typography>
            </Grid>

            {
                state.showProgress && <Grid container direction='row' justify='center'>
                    <CircularProgress color='secondary'/>
                </Grid>
            }

            {
                state.link && <TextField
                    focused={state.link}
                    onSelect={(e) => {
                        e.target.select()
                    }}

                    label="Message Share link" value={state.link}
                    variant='outlined' style={styles.linktextfield}/>
            }

            <Grid style={{padding: 16}} container direction='row' justify='space-evenly' alignItems='center'
                  alignContent='center'>
                <Grid item xs style={styles.buttonGrid}>
                    <Button onClick={() => {
                        BusinessLogics.addData(state, actions)
                    }} disabled={state.add.message.length == 0 || state.add.message.length > 1000 || state.link}
                            style={styles.buttons} color='primary'
                            variant='contained'>SAVE</Button>
                </Grid>

                <Grid item xs style={styles.buttonGrid}>
                    <Button onClick={() => {
                        BusinessLogics.deleteData(state, actions, changeRoute)
                    }} disabled={!state.link} style={styles.buttons} color='primary'
                            variant='contained'>DELETE</Button>
                </Grid>
            </Grid>

            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                onClose={() => {
                    actions.setSnackbarMessage("")
                }}
                message={state.snackbarMessage}
                open={state.snackbarMessage}
                autoHideDuration={4000}
            />

        </Grid>
    );
};

export default DataAdderShowerDeleter;
